import { render, staticRenderFns } from "./EditBuySizeRule.vue?vue&type=template&id=1978acb9&scoped=true"
import script from "./EditBuySizeRule.vue?vue&type=script&lang=js"
export * from "./EditBuySizeRule.vue?vue&type=script&lang=js"
import style0 from "./EditBuySizeRule.vue?vue&type=style&index=0&id=1978acb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978acb9",
  null
  
)

export default component.exports